export default __webpack_public_path__ + "static/media/playlist-cover-1.6163094c.png";